<template>
  <div id="app" v-loading.fullscreen.lock="fullscreenLoading">
    <mat-header :showStatus="showdate"/>
    <router-view/>
  </div>
</template>
<script>
import MatHeader from './components/MatHeader'
export default {
  name: 'App',
  data(){
    return{
      showdate: false,
      fullscreenLoading: false
    }
  },
  components: { MatHeader }
}
</script>

<style>
body{
  color: #333333;
  font-size: 14px;
  width: 100%;
  height: 100%;
}
#app{
  width: 100%;
  height: 100%;
}
.mat-s-btn{
  width: 108px;
  height: 40px;
  display: block;
  text-align: center;
  background-color: #438BCA;
  line-height: 40px;
  color: #ffffff;
  border-radius: 5px;
  margin: 0 auto;
  cursor: pointer;
  margin-top: 24px;
  margin-bottom: 72px;
}
.el-input--suffix, .el-input__inner{
  width: 300px;
  height: 32px;
}
.el-input__icon{
  line-height: 32px;
}
.mat-s-btn:hover{ opacity: 0.8;}
input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #aab2bd;
  /* placeholder字体大小  */
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue